import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../../lib/api'
import type { AdminPatientRow } from '../../lib/types'

const MILESTONE_LABELS: Record<string, string> = {
  not_matched: 'Not matched',
  matched_no_session_1: 'Matched, no Session 1',
  session_1_attended: 'Session 1 attended',
  approaching_session_4: 'Approaching Session 4',
  session_4_reached: 'Session 4 reached',
  stalled: 'Stalled',
}

export default function AdminPatients() {
  const [patients, setPatients] = useState<AdminPatientRow[]>([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    setLoading(true)
    api('/admin/patients?limit=200').then((rows) => { setPatients(rows); setLoading(false) })
  }, [])

  const filtered = patients.filter((p) => {
    if (!search.trim()) return true
    const q = search.trim().toLowerCase()
    return p.name.toLowerCase().includes(q) || (p.email || '').toLowerCase().includes(q)
  })

  if (loading) return <div className="page-loading">Loading patients…</div>

  return (
    <div>
      <div className="page-head">
        <h1>Patients / care seekers</h1>
        <div className="ph-sub">Operational profile only — no clinical notes, treatment plans, or intake content are shown here.</div>
      </div>

      <input
        className="inp"
        style={{ maxWidth: 280, marginBottom: 14 }}
        placeholder="Search by name or email…"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <div className="table-wrap">
        <table className="data-table">
          <thead>
            <tr>
              <th>Name</th><th>Contact</th><th>Intake status</th><th>Match status</th>
              <th>Selected provider</th><th>Continuity milestone</th><th>Case status</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((p) => (
              <tr key={p.id} onClick={() => navigate(`/admin/patients/${p.id}`)} style={{ cursor: 'pointer' }}>
                <td>{p.name}</td>
                <td className="muted">{p.email || p.phone || '—'}</td>
                <td><span className={`badge ${p.intake_status === 'started' ? 'badge-blue' : 'badge-grey'}`}>{p.intake_status || 'unknown'}</span></td>
                <td><span className={`badge ${p.match_status === 'matched' ? 'badge-green' : 'badge-grey'}`}>{p.match_status || 'unknown'}</span></td>
                <td>{p.selected_provider_name || '—'}</td>
                <td>{MILESTONE_LABELS[p.continuity_milestone] || p.continuity_milestone}</td>
                <td className="muted">{p.case_status || '—'}</td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan={7} className="muted">{patients.length === 0 ? 'No patients yet.' : 'No patients match this search.'}</td></tr>}
          </tbody>
        </table>
      </div>

      <p className="legal-note">
        This view is operational only. Presenting concerns, risk flags, intake content, diagnoses, assessments,
        and any clinical or therapist notes are intentionally excluded from this admin surface.
      </p>
    </div>
  )
}
